import { render } from "./Baby.vue?vue&type=template&id=4b6ab7ab&scoped=true&lang=pug"
import script from "./Baby.vue?vue&type=script&lang=js"
export * from "./Baby.vue?vue&type=script&lang=js"

import "./Baby.vue?vue&type=style&index=0&id=4b6ab7ab&scoped=true&lang=css"

import exportComponent from "/Users/bestian/Documents/GitHub/food-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6ab7ab"]])

export default __exports__